import React from 'react'
import Sketch from 'react-p5'

import Matter from "matter-js"

import LocalizedStrings from 'react-localization';
import {LanguageContext} from "./LanguageContext"

let strings = new LocalizedStrings({
    en:{
        title:"xy",
        description:""
    },
    de: {
        title:"xy",
        description:""
    }
});

const extensions = require("./extensions")

class XYPoem extends React.Component {
    constructor(props) {
        super(props)

        this.engine = null
        this.world = null
        this.columns = 9
        this.fontSize = 10

        this.reset = this.reset.bind(this)
        this.setup = this.setup.bind(this)
        this.draw = this.draw.bind(this)
        this.windowResized = this.windowResized.bind(this)
    }

    componentDidMount() {
        this.props.onchangePoemInfo(strings)
    }

    reset(p5) {
        this.engine = Matter.Engine.create();
        this.world = this.engine.world;

        this.world.gravity.scale = 0.0001

        this.fontSize = Math.floor(window.innerHeight / 20)
        this.columns = Math.floor(window.innerWidth / this.fontSize / 3)

        p5.textFont("DejaVuSerif");
        p5.textSize(this.fontSize)

        Matter.World.add(this.world, extensions.makeWalls(p5, false, true, true, true))

        Matter.World.add(this.world, this.tower(p5, 0.5*p5.width/4, 0, p5.height, "X"))
        Matter.World.add(this.world, this.tower(p5, 2.5*p5.width/4-this.fontSize*2, 0, p5.height, "Y"))
    }

    setup(p5, canvasParentRef) {
        p5.createCanvas(window.innerWidth, window.innerHeight).parent(canvasParentRef)
        p5.background(0)

        this.reset(p5)
    }

    tower(p5, x, y, h, char) {
        var towerCharacters = []
        const lines = Math.round(h/this.fontSize)
        for (var i = 0; i < lines; i++) {
            for (var c = 0; c < this.columns; c++) {
                towerCharacters.push(extensions.makePhysicsCharacter(p5, p5.random()*2+x+c*this.fontSize*0.9, y+i*this.fontSize, char, this.fontSize))
            }
        }

        return towerCharacters
    }

    draw(p5) {
        p5.background(0)
        if (this.world !== undefined) {
            Matter.Engine.update(this.engine);

            var bodies = Matter.Composite.allBodies(this.engine.world);

            for (var i = 0; i < bodies.length; i += 1) {
                var body = bodies[i]

                extensions.drawPhysicsCharacter(p5, body)
            }
        }
    }

    windowResized(p5) {
        p5.resizeCanvas(window.innerWidth, window.innerHeight)

        this.reset(p5)
    }

    render() {
        strings.setLanguage(this.context.language)
        return <Sketch setup={this.setup} draw={this.draw} windowResized={this.windowResized} />
    }
}
XYPoem.contextType = LanguageContext

export default XYPoem
